<section #tab class="page-content tw-flex tw-flex-col tw-w-full">

    <div style="float: left">
        <section class="page-header">
            <h1 class="page-title"><em class="fal fa-sliders tw-mr-2"></em>Document Type Manager</h1>
        </section>
    </div>

    <p-splitter [panelSizes]="[20,80]" layout="horizontal">

        <ng-template pTemplate>

            <section class="tw-flex tw-flex-col tw-w-full overflow-hidden">
                <section class="tw-flex tw-w-full tw-h-full tw-flex-col tw-basis-full">
                    <p-toolbar>
                        <div class="p-toolbar-group-left tw-ml-3">
                            <i class="fal fa-bars-staggered tw-mr-2"></i>
                            <p-dropdown #treeOrderOptions [options]="categoryOptions" [(ngModel)]="selectedCategory" optionLabel="name"
                                (onChange)="categorizeByChanged($event)"></p-dropdown>
                        </div>
                        <button pButton pRipple icon="fal fa-plus" class="p-button-rounded tw-order-2"
                            (click)="addDocumentType()" pTooltip="Add New Document Type"
                            tooltipPosition="left"></button>
                    </p-toolbar>
                    <div class="tw-h-[81.35vh]" >
                        <p-tree #docTypeTree [value]="this.categorizedDocTypes" selectionMode="single"
                                [(selection)]="selectedDocumentType"  [style]="{'height': '100%'}"
                                (onNodeSelect)="this.documentTypeSelected($event)" filterMode="strict"
                                filterPlaceholder="Strict Filter" scrollHeight="70vh">
                            <ng-template pTemplate="header">
                                    <p-toolbar>
                                        <div class="p-toolbar-group-left">
                                            <span *ngIf="ready" class="p-float-label">
                                                <input type="text" pInputText placeholder="Search" [(ngModel)]="searchValue"
                                                    (ngModelChange)="filterConfig(searchValue)" />
                                                <label>Search Document Types</label>
                                            </span>
                                            <button pButton pRipple type="button" icon="fal fa-eraser" style="height: 40px; left:-2px;"
                                                (click)="clearSearch()"></button>
                                        </div>
                                    </p-toolbar>
                            </ng-template>
                        </p-tree>
                    </div>
                </section>
            </section>
        </ng-template>

        <ng-template pTemplate>
            <section class="tw-flex tw-flex-col tw-w-full overflow-hidden">
                <section class="tw-flex tw-h-full tw-flex-row">
                    <app-document-type-item [documentTypeId]="this.selectedDocumentType?.key ?? 0" (documentTypeAddition)="documentTypeAdded($event)"
                        (documentTypeRemoval)="documentTypeRemoved()"></app-document-type-item>
                </section>
            </section>
        </ng-template>
    </p-splitter>
</section>
